import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { FooterComponent } from './components/footer/footer.component';
import { ContactComponent } from './components/contact/contact.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { PagenotfoundComponent } from './components/pagenotfound/pagenotfound.component';
import { AboutusComponent } from './components/aboutus/aboutus.component';
import { ProductComponent } from './components/product/product.component';
import { BestellsiteComponent } from './components/bestellsite/bestellsite.component';
import { RechtlichesComponent } from './components/rechtliches/rechtliches.component';
import { ZubereitungComponent } from './components/zubereitung/zubereitung.component';

const routes: Routes = [{path:'', component: HomeComponent},
{path: 'home', component: HomeComponent},
{path: 'about-us', component: AboutusComponent},
{path: 'navigation', component: NavigationComponent},
{path: 'footer', component: FooterComponent},
{path: 'product', component: ProductComponent},
{path: 'contact', component: ContactComponent},
{path: 'order', component: BestellsiteComponent},
{path: 'preperation', component: ZubereitungComponent},
{path: 'rights', component: RechtlichesComponent},

{path: '**', component: PagenotfoundComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }


